import { Attachment } from '@/types/types';
import httpClient from './httpClient';

class AppApi {
	async createAttachment({
		file,
		isTemp,
	}: {
		file: File | Blob | string;
		isTemp?: true;
	}) {
		const attachmentBody = new FormData();
		attachmentBody.append('file', file);

		let endpoint = 'attachments';
		if (isTemp) endpoint += '/tmp';

		const response = await httpClient.post<Attachment>(
			endpoint,
			attachmentBody
		);

		return response.data;
	}

	async createARModel(glb: ArrayBuffer) {
		const file = new File([glb], 'preview.glb', { type: 'model/gltf-binary' });
		const formData = new FormData();
		formData.append('file', file);

		const response = await httpClient.post<Attachment>(
			'attachments/tmp',
			formData
		);

		return response.data;
	}
}

export default new AppApi();
